import { render, staticRenderFns } from "./PromotionBusinessInteligence.vue?vue&type=template&id=45c6f3d7"
import script from "./PromotionBusinessInteligence.vue?vue&type=script&lang=js"
export * from "./PromotionBusinessInteligence.vue?vue&type=script&lang=js"
import style0 from "./PromotionBusinessInteligence.vue?vue&type=style&index=0&id=45c6f3d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports